import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ids"];
import { compact, isEmpty, uniq } from 'lodash';
import { useAxiosClient } from '../hooks';
import { createQueryKey, sanitizeParams } from '../utils';
import useQuery from './useQuery';
export default function useFindByIds(variant, basePath, _ref, options) {
  let {
      ids
    } = _ref,
    params = _objectWithoutPropertiesLoose(_ref, _excluded);
  const axiosClient = useAxiosClient();
  const idsSanitized = uniq(compact(ids));
  async function queryFn() {
    var _response$data;
    const url = variant.replace('{basePath}', basePath);
    const response = await axiosClient.get(url, {
      params: _extends({
        _id: idsSanitized.join(',')
      }, sanitizeParams(params))
    });
    return ((_response$data = response.data) == null ? void 0 : _response$data.response) || response.data || [];
  }
  const queryKey = createQueryKey(basePath, variant, params, idsSanitized);
  return useQuery(queryKey, queryFn, _extends({}, options, {
    enabled: (options == null ? void 0 : options.enabled) || !isEmpty(idsSanitized)
  }));
}